<section id="about" >
  <div class="container">

  <header class="section-header">
    <h1 class="section-title" style="text-align: center;">Accounts Payable Automation Software Solution</h1>
  </header>

  <div class="row row-eq-height justify-content-center">
      <div class="row about-container">
        
          <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">           
            <div class="icon-box wow fadeInUp">
              <div class="icon"><i class="fa fa-check-circle"></i></div>
              <h4 class="title"><a href="">Electronic Data Processing</a></h4>
              <p class="description">Supplier documents such as price updates, order confirmations, shipping notices,
                bills of lading, packing lists, invoices, etc. enter the system directly as electronic
                data if the supplier has already converted to electronic communication</p>
            </div>

            <div class="icon-box wow fadeInUp" data-wow-delay="0.2s">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
              <h4 class="title"><a href="">Web Based Invoice Repositery</a></h4>
              <p class="description">If the supplier is still relying on paper or fax, the documents are collected by
                System, digitized, identified, and stored online in web-based data repository for
                retrieval and continued work.</p>
            </div>

            <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
              <h4 class="title"><a href="">Three-way invoice matching</a></h4>
              <p class="description">Match technology processes the data on each document based on business rules
                set up when we personalized the customer’s system. Match Process always makes
                sure the quantity, price and total amounts to be paid are verified as correct before
                the customer pays any invoice, but far more complex matching is often done based
                on a customer’s specific goals and needs. Three-way matching is a procedure for processing a vendor
                invoice to ensure that a payment is complete and accurate. The goal of three-way matching is to highlight 
                any discrepancies in three important documents in the purchasing process – purchase orders, order 
                receipts/packing slips, and invoices – in order to save businesses from overspending or paying for an 
                item that they did not receive.
              </p>
            </div>
                <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">Purchase orders Tracking</a></h4>
                <p class="description">
                A purchase order is the official confirmation of an order. Company purchasing the 
                goods or services, date, the description and quantity of the goods or services, price, a mailing address, 
                payment information, invoice address, and a purchase order number.
                Order receipts/packing slips – This is the proof of payment and delivery. An order receipt is included by 
                the vendor with goods that have been delivered to the purchaser. It details exactly what is in the shipment or 
                order. Order receipts typically include the same information as in the invoice, as well as the method of payment.
                Invoices – An invoice requests payment for a purchase. Invoices are sent from the vendor to the purchaser. 
                They include the same information as in the purchase order, as well as an invoice number, vendor contact 
                information, any credits or discounts for early payments, payment schedule, and total amount due to the vendor.
                Before an invoice is paid, accounts payable reviews the quantities, prices, and terms to ensure that what is 
                ordered (via the purchase order) matches the goods received (via the order receipt/packing slip) which matches 
                what they are being charged (via the invoice).
            
                </p>
            </div>

            <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
            <div class="icon"><i class="fa fa-check-circle"></i></div>
          <h4 class="title"><a href="">Accounts Payable Software for Small Business</a></h4>
          <p class="description">
            Save accounts payable processing time and increase productivity with our easy-to-use accounts payable software solutions. We have helped many of our clients to automate manual accounts payable processes and eliminate inefficient workflows. you can track and view invoices, payments, and reports anytime with 24/7 access from any device.

          </p>
      </div>

                                      
          </div>
         


          <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">
           
  
            <div class="icon-box wow fadeInUp">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">Invoice Tracking</a></h4>
                <p class="description">The main responsibility of the accounts payable department is to process
                  and review transactions from their suppliers. In other words, it is the
                  accounts payables departments Job to ensure all outstanding invoices from
                  their suppliers are approved, processed, and paid.
                  </p>
              </div>

                  <div class="icon-box wow fadeInUp">
                    <div class="icon"><i class="fa fa-check-circle"></i></div>
                    <h4 class="title"><a href="">Avoid human error</a></h4>
                    <p class="description">This can lead to a host of problem including human error during data entry,
                      lost invoices, late payments, invoice duplicates, and even double payments. </p>
                  </div>
                  <div class="icon-box wow fadeInUp">
                      <div class="icon"><i class="fa fa-check-circle"></i></div>
                      <h4 class="title"><a href="">Centralize transactions</a></h4>
                      <p class="description">Electronic Invoicing can be a very useful tool for the AP department. It
                        centralizes all transactional documents in one location on a web server. So they can be easily 
                        found and processed.Reduce the cost of invoice processes by increasing the level of automation.
                        Speed processing by lowering the number of days needed to reconcile a disputed invoice.
                        </p>
                    </div>
                        
                         <div class="icon-box wow fadeInUp">
                            <div class="icon"><i class="fa fa-check-circle"></i></div>
                            <h4 class="title"><a href="">Standardized interfaces</a></h4>
                            <p class="description">Reduce costs by using standardized interfaces to SAP ERP and 
                              SAP Invoice Management by OpenText.
                              · Match technology processes the data on each document based on business rules
                              set up when we personalized the customer’s system. Match Process always makes
                              sure the quantity, price and total amounts to be paid are verified as correct before
                              the customer pays any invoice, but far more complex matching is often done based
                              on a customer’s specific goals and needs.
                              · Perfect transactions flow straight through to the customer’s payment registry. The
                              customer has control over when to actually submit the transactions from the
                              registry to their financial system for payment.
                              · Transactions with discrepancies are automatically detected by Invoice processing
                              system, and routed in real time via alerts to the desktops of the exact employees
                              responsible for resolving the issues.
                              · Once any discrepancies are resolved and necessary approvals attained, the
                              perfected transaction flows through to our customer’s payment registry. The
                              customer controls when to submit transactions from the registry for payment.  </p>
                          </div>
                          
                          <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                              <div class="icon"><i class="fa fa-check-circle"></i></div>
                              <h4 class="title"><a href="">Discrepancies finder</a></h4>
                              <p class="description">Transactions with discrepancies are automatically detected by Invoice processing
                                system, and routed in real time via alerts to the desktops of the exact employees
                                responsible for resolving the issues. Once any discrepancies are resolved and necessary approvals attained, 
                                the perfected transaction flows through to our supplier’s payment registry. The
                                supplier controls when to submit transactions from the registry for payment.</p>
                            </div>
            
                          
          </div>
        </div>      
    </div>
</div>
</section>